export default __webpack_public_path__ + "static/award-43fc9401d02bca70f4fd71645b28e325.jpg";